import React, {useState} from 'react';
import {getUserFriendlyErrorMessage} from '@/utils/errorHandling.ts';
import {
  Button,
  ButtonVariant,
  Label,
  useModal,
  useToast
} from '@fs/uikit-react';
import styles from './PersonModalDelete.module.css';
import { Person } from '../../../types/person.ts';
import { PersonApi } from '../../../api/PersonApi.ts';
import {ApiError} from '@/services/api';

interface PersonModalDeleteProps {
  person: Person;
  onSuccess: () => void;
}

const PersonModalDelete: React.FC<PersonModalDeleteProps> = ({ person, onSuccess }) => {
  const { closeModal } = useModal();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    setIsLoading(true);

    try {
      await PersonApi.delete(person.id || '');
      toast.showSuccessToast('Успішно', 'Особу успішно видалено');
      closeModal();
      onSuccess();
    } catch (error) {
      console.error('Error deleting person:', error);
      toast.showErrorToast(
        'Помилка видалення особи',
        getUserFriendlyErrorMessage(error as ApiError)
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.modalContent}>
      <Label
        text={'Ви впевнені, що хочете видалити особу "' +
          (person.lastName || '') + ' ' +
          (person.firstName || '') + ' ' +
          (person.fathersName || '') +
          '"?'
        }
      />
      <div className={styles.buttonGroup}>
        <Button
          title={isLoading ? 'Видалення...' : 'Видалити'}
          onClick={handleDelete}
          loading={isLoading}
          variant={ButtonVariant.DESTRUCTIVE}
        />
        <Button
          title="Скасувати"
          onClick={closeModal}
          variant={ButtonVariant.SECONDARY}
        />
      </div>
    </div>
  );
};

export default PersonModalDelete;
